// extracted by mini-css-extract-plugin
export default {"nav":"WSNav-module_nav-kZHtC","footer":"WSNav-module_footer-yn5LM"};